import * as React from 'react';

import './styles/App.css';
import Accept from './pages/acceptancePage';
import Reject from './pages/rejectionPage';
import Error from './pages/errorPage';
import { HttpService } from './services/apiService';
// eslint-disable-next-line no-unused-vars
import favicon from './assets/favicon.ico';
//disabled for .ico bundling during build time as per webpack.config.js
import HeaderLine from '../src/components/headerLine/headerLine'
import _gConstants from './configuration/constants.json';
import _gEndpoints from './configuration/endPoints.json';
import { Flyout } from '../src/components/flyout/flyout';
import { Button } from "@material-ui/core";
import ChevronUpSystem from "../src/assets/img/chevronUpSystem";
import MinusSystem from "../src/assets/img/minusSystem";
import { useRef } from 'react';

function App() {
  let _vIsAccept = window.location.href.indexOf(_gConstants.ACCEPT_URL_SUBSTRING) !== -1;
  let _vIsReject = window.location.href.indexOf(_gConstants.REJECT_URL_SUBSTRING) !== -1;
  let _vSearch = window.location.search;
  let _vParams = new URLSearchParams(_vSearch);
  let _vUniqueID = _vParams.get(_gConstants.UID);
  let _vEndpoint = '';
  const [_vLoader, setLoader] = React.useState(true);
  const [_vStatus, setStatus] = React.useState(false);
  const [_vIsAcceptStatus, setAcceptStatus] = React.useState(false);
  const [popupOverflow, setPopupOverflow] = React.useState("scrollVisible");
  let _vHttpService = new HttpService();
  const scrollButton = window.onscroll = function() {scrollFunction()};
  const buttonValues = useRef();
  function scrollFunction() {
    if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
      buttonValues.current.style.display = "block";
    } else {
      buttonValues.current.style.display = "none";
    }
  }
  function scrollToTop() {
  document.documentElement.scrollTop = 0;
  }
  React.useEffect(() => { 

    if (_vIsAccept) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      _vEndpoint = _gEndpoints[process.env.NODE_ENV].GETACCEPT_ENDPOINT;
      setAcceptStatus(true);
    } else if (_vIsReject) {
      _vEndpoint = _gEndpoints[process.env.NODE_ENV].GETREJECT_ENDOINT;
    } else {
      setLoader(false);
      setStatus(false);
    }
    if (_vEndpoint !== '') {
      let _vHeaders = {
        'client_secret': process.env.REACT_APP_CI_EECC_FE_SECRET,
        'uid': _vUniqueID
        // TODO headers to be added based on actual endpoint details
      };      
      _vHttpService.http(_gEndpoints[process.env.NODE_ENV].HOST,_vEndpoint, _gConstants.GET, '', _vHeaders,
        (_cbpStatus,_cbpResult) => {          
          setLoader(false);
          _cbpStatus === 200
            ? setStatus(true)
            : setStatus(false);
        }, (_cbpError) => {          
          setLoader(false);
          setStatus(false);
        })
    }
  }, []);

  return (
    <div className={popupOverflow}>
      <HeaderLine></HeaderLine>
      {_vLoader ? (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <span className="loader" />
        </div>
        //  ) : _vStatus===false ? (
        //   _vIsAcceptStatus===true ? (
      ) : _vStatus? (
        _vIsAcceptStatus ? (
          <>
            <Accept uid={_vUniqueID}/>
          </>
        ) : (
            <Reject />
          )
      ) : (
            <Error />
          )}
                <Flyout setPopupOverflow={setPopupOverflow}></Flyout>
                <div ref={buttonValues} className="back-to-top-button" id="myBtn">
                <Button  className="chevron-button" onClick={scrollToTop.bind()}><ChevronUpSystem className="chevron-icon"></ChevronUpSystem><MinusSystem className="minus-icon"></MinusSystem></Button>
                </div>
    </div>
  );
}

export default App;
